import React, {FC, ReactElement, useEffect, useRef, useState} from 'react';
import {Action, Dispatch} from 'redux';

const CLICK_COUNT = 5;

const updateFeatureFlagInStore = (
  featureToSet: string,
  features: string[],
  actionCreator: (features: string[]) => Action<string>,
  dispatch: Dispatch<Action<string>>,
): string => {
  const [newFeatures, setState] = features.includes(featureToSet) ?
    [features.filter(feature => feature !== featureToSet), 'inactive'] :
    [[...features, featureToSet], 'active'];

  dispatch(actionCreator(newFeatures));
  return setState;
};

interface EasterEggWrapperProps {
  featureToSet: string,
  features: string[],
  actionCreator: (features: string[]) => Action<string>,
  dispatch: Dispatch<Action<string>>,
  isEasterEggEnabled: boolean,
  children: ReactElement,
}

export const EasterEggWrapper: FC<EasterEggWrapperProps> = (
  {featureToSet, features, actionCreator, dispatch, isEasterEggEnabled, children},
) => {
  const [clickStore, setClickStore] = useState<number>(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!timerRef.current && clickStore > 0) {
      timerRef.current = setTimeout(() => {
        setClickStore(0);
        timerRef.current = null;
      }, 2000);
    }

    if (isEasterEggEnabled && clickStore === CLICK_COUNT) {
      const result = updateFeatureFlagInStore(featureToSet, features, actionCreator, dispatch);
      console.log(`Set feature flag ${featureToSet} ${result}`);
    }
  }, [clickStore]);

  return (
    <div onClick={() => setClickStore(clickStore + 1)} >
      {children}
    </div>
  );
};
